import type {AmenityType} from "../types";

export type AmenityConfig = {
  type: AmenityType;
  /** API path segment, e.g. poolaccesslog, tennisaccesslog */
  accessLogPath: string;
  accessLogsListPath: string;
  /** Facility API segment, e.g. property_amenity, tennis_amenity */
  facilityPath: string;
  facilitiesListPath: string;
  /** Nav / property section keys */
  accessLogsSectionKey: string;
  facilitiesSectionKey: string;
  routeAccessLogs: string;
  routeFacilities: string;
  labelAccessLogs: string;
  labelFacilities: string;
  labelFacilitySingular: string;
  guestRuleKey: string;
  guestRuleFeature: string;
};

export const POOL_CONFIG: AmenityConfig = {
  type: "pool",
  accessLogPath: "poolaccesslog",
  accessLogsListPath: "poolaccesslogs",
  facilityPath: "property_amenity",
  facilitiesListPath: "property_amenities",
  accessLogsSectionKey: "poolaccesslogs",
  facilitiesSectionKey: "pools",
  routeAccessLogs: "/poolaccesslogs",
  routeFacilities: "/pools",
  labelAccessLogs: "Pool access logs",
  labelFacilities: "Pools",
  labelFacilitySingular: "Pool",
  guestRuleKey: "number_of_guest_in_pool",
  guestRuleFeature: "poolaccesslogs",
};

export const TENNIS_CONFIG: AmenityConfig = {
  type: "tennis",
  accessLogPath: "tennisaccesslog",
  accessLogsListPath: "tennisaccesslogs",
  facilityPath: "tennis_amenity",
  facilitiesListPath: "property_amenities",
  accessLogsSectionKey: "tennisaccesslogs",
  facilitiesSectionKey: "tennis",
  routeAccessLogs: "/tennisaccesslogs",
  routeFacilities: "/tennis",
  labelAccessLogs: "Tennis access logs",
  labelFacilities: "Tennis courts",
  labelFacilitySingular: "Court",
  guestRuleKey: "number_of_guest_in_tennis",
  guestRuleFeature: "tennisaccesslogs",
};

export const GYM_CONFIG: AmenityConfig = {
  type: "gym",
  accessLogPath: "gymaccesslog",
  accessLogsListPath: "gymaccesslogs",
  facilityPath: "gym_amenity",
  facilitiesListPath: "property_amenities",
  accessLogsSectionKey: "gymaccesslogs",
  facilitiesSectionKey: "gym",
  routeAccessLogs: "/gymaccesslogs",
  routeFacilities: "/gym",
  labelAccessLogs: "Gym access logs",
  labelFacilities: "Gyms",
  labelFacilitySingular: "Gym",
  guestRuleKey: "number_of_guest_in_gym",
  guestRuleFeature: "gymaccesslogs",
};

export const RECREATION_CONFIG: AmenityConfig = {
  type: "recreation",
  accessLogPath: "recreationaccesslog",
  accessLogsListPath: "recreationaccesslogs",
  facilityPath: "recreation_amenity",
  facilitiesListPath: "property_amenities",
  accessLogsSectionKey: "recreationaccesslogs",
  facilitiesSectionKey: "recreation",
  routeAccessLogs: "/recreationaccesslogs",
  routeFacilities: "/recreation",
  labelAccessLogs: "Recreation access logs",
  labelFacilities: "Recreation areas",
  labelFacilitySingular: "Area",
  guestRuleKey: "number_of_guest_in_recreation",
  guestRuleFeature: "recreationaccesslogs",
};

export const AMENITY_CONFIGS: AmenityConfig[] = [
  POOL_CONFIG,
  TENNIS_CONFIG,
  GYM_CONFIG,
  RECREATION_CONFIG,
];

const ACCESS_LOG_FEATURE_TO_CONFIG: Record<string, AmenityConfig> = {
  [POOL_CONFIG.accessLogsSectionKey]: POOL_CONFIG,
  [TENNIS_CONFIG.accessLogsSectionKey]: TENNIS_CONFIG,
  [GYM_CONFIG.accessLogsSectionKey]: GYM_CONFIG,
  [RECREATION_CONFIG.accessLogsSectionKey]: RECREATION_CONFIG,
};

export const AMENITY_ACCESS_LOG_FEATURE_KEYS = Object.keys(ACCESS_LOG_FEATURE_TO_CONFIG);

export function isAmenityAccessLogFeatureKey(featureKey: string): boolean {
  return featureKey in ACCESS_LOG_FEATURE_TO_CONFIG;
}

export function getAmenityConfigForAccessLogFeature(featureKey: string): AmenityConfig | undefined {
  return ACCESS_LOG_FEATURE_TO_CONFIG[featureKey];
}
